import { JSX } from "react";

import { Loader } from "./Loader";

import "./OverlayLoader.scss";

type Props = {
  isLoading: boolean;
  children: JSX.Element;
  backgroundColor?: "white" | "transparent";
};

export default function OverlayLoader({
  isLoading,
  children,
  backgroundColor = "white"
}: Props) {
  return (
    <div className="overlayLoaderWrapper">
      {isLoading && (
        <div className={`overlayLoader ${backgroundColor}`}>
          <Loader className="overlayLoaderSpinner" />
        </div>
      )}
      {children}
    </div>
  );
}
